import { Component, OnInit, ViewChild } from '@angular/core';
import { FilterRequest } from '../../requets/shared/model/filter-request.model';
import { RequestService } from '../../requets/shared/request.service';
import { RequetsEvaluator } from '../shared/requets-evaluator.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssessmentsComponent } from '../assessments.component';

@Component({
  selector: 'app-assessments-evaluator',
  templateUrl: './assessments-evaluator.component.html',
  styleUrls: ['./assessments-evaluator.component.scss']
})
export class AssessmentsEvaluatorComponent implements OnInit {

  requests: RequetsEvaluator[];
  enabledSpinner = false;
  @ViewChild(AssessmentsComponent) assessmentComponent: AssessmentsComponent;


  constructor(private requestService: RequestService,
              private location: Location,
              private router: Router) { }

  ngOnInit() {
    this.getListRequests(new FilterRequest());
  }

  getListRequests(filterRequest: FilterRequest) {
    filterRequest.evaluador = localStorage.getItem('cedula');
    this.requestService.getRequest(filterRequest).subscribe(
      (result) => {
        if (result.data) {
            this.requests = result.data as RequetsEvaluator[];
            this.enabledSpinner = false;
        }
      }
    );
  }

  sendFilter(event: FilterRequest) {
    this.enabledSpinner = true;
    this.getListRequests(event);
    this.assessmentComponent.messageError = '';
  }
  showCurriculum() {
      window.open('https://www.udea.edu.co/wps/portal/udea/web/inicio/estudiar-udea/pregrado/oferta/');
  }

  showRegulation() {
      this.router.navigate(['reglamento']);
  }


}
